module.exports = __webpack_public_path__ + "img/ep-rond-festonne.0568a8c4.jpg";